import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { GlobalLoading, Modal } from '@/shared/components';
import { useAppStore } from '@/store/app-store';
import { usePriceStore } from '@/store/price-store';
import { useCartStore } from '../cart-store';
import { cartService } from '@/services/cart.service';
import { PriceRequest } from '@/types/cart';
import { handleFetchResult } from '@/app/utils/price-availability';

export const CartQtpModel = ({
  qtpConfirmModal,
  handleClose,
  handleSave,
  type,
  currentItem,
}: {
  qtpConfirmModal: string | boolean;
  handleClose: () => void;
  handleSave: () => void;
  type: 'mandatory' | 'optional';
  currentItem: PriceRequest[];
}) => {
  const { t } = useLang(NAMESPACE.cart);
  const { promotionInfo, setPromotionInfo } = usePriceStore();
  return (
    <Modal
      saveButtonLabel={t('remove')}
      cancelButtonLabel={t('close')}
      className="w-[520px]"
      isOpen={!!qtpConfirmModal}
      size="medium"
      title={t('remove.item')}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleSave={async () => {
        GlobalLoading.show();
        if (type === 'mandatory') {
          usePriceStore.getState().setPromotionInfo(null);
        } else {
          const billToId = useAppStore.getState()?.billToInfo?.accountNumber;
          const shipTo =
            useCartStore.getState().address?.accountNumber ??
            useAppStore.getState()?.shipToList?.find((item) => item.isDefault)?.accountNumber;
          const result = await cartService.getProductPrice(currentItem, shipTo, billToId);
          const qtpSKUMap = promotionInfo?.qtpSKUMap;
          if (qtpSKUMap) {
            const updatedQtpSKUMap = { ...promotionInfo.qtpSKUMap };
            currentItem.forEach((item) => {
              if (qtpSKUMap[item.catalogNumber]) {
                delete updatedQtpSKUMap[item.catalogNumber];
              }
            });
            setPromotionInfo({ ...promotionInfo, qtpSKUMap: updatedQtpSKUMap });
          }
          handleFetchResult(result);
        }
        handleClose();
        handleSave();
        GlobalLoading.hide();
      }}
    >
      <div>
        <p
          dangerouslySetInnerHTML={{
            __html: t(`remove.QTP.${type}.promotion`, {
              Name: usePriceStore.getState().promotionInfo?.promoName || '',
            }),
          }}
        ></p>
      </div>
    </Modal>
  );
};
